import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, useAuth } from '@/App';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processOAuthCallback = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/auth');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const { user } = response.data;
        setAuthUser(user);

        // Clear the hash and redirect to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { state: { user }, replace: true });
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/auth');
      }
    };

    processOAuthCallback();
  }, [navigate, setAuthUser]);

  return (
    <div className="pt-20 min-h-screen flex flex-col items-center justify-center" data-testid="auth-callback">
      <Loader2 className="w-12 h-12 text-[#FF3B30] animate-spin mb-6" />
      <h2 className="heading-display text-xl text-white">Signing you in...</h2>
    </div>
  );
}
